import type { SegmentCriterionSegmentCriterionReadModelChoicesItem } from '@r/api/generated/client.schemas.ts';

/** Retourne la valeur à soumettre pour un choix : la chaîne elle-même, ou l'id si c'est un objet dynamique. */
export function getChoiceValue(
  choice: SegmentCriterionSegmentCriterionReadModelChoicesItem
): string {
  if (typeof choice === 'string') return choice;
  return String((choice as Record<string, number | string>).id ?? '');
}

/** Retourne le libellé à afficher pour un choix : la traduction pour une chaîne fixe, ou le nom pour un objet dynamique. */
export function getChoiceLabel(
  choice: SegmentCriterionSegmentCriterionReadModelChoicesItem,
  t: (key: string) => string
): string {
  if (typeof choice === 'string') return t(choice);
  const record = choice as Record<string, number | string>;
  return String(record.name ?? record.id ?? '');
}
